import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "./context/CartContext";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import FitQuiz from "./pages/FitQuiz";

import { initAnalytics, trackPageView } from "./lib/analytics";

const TOAST_OPTIONS = {
  style: {
    background: "#1a1814",
    color: "#f0e9e1",
    border: "1px solid rgba(240,233,225,0.15)",
    borderRadius: 0,
    fontFamily: "Manrope, sans-serif",
    letterSpacing: "0.04em",
    fontSize: 13,
  },
};

function AnalyticsListener() {
  const location = useLocation();
  useEffect(() => {
    initAnalytics();
  }, []);
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#f0e9e1] text-[#1a1814]">
      <BrowserRouter>
        <CartProvider>
          <AnalyticsListener />
          <Nav />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:slug" element={<ProductDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/fit-quiz" element={<FitQuiz />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
            </Routes>
          </main>
          <Footer />
          <CartDrawer />
          <Toaster
            position="bottom-right"
            richColors
            closeButton
            duration={4000}
            toastOptions={TOAST_OPTIONS}
          />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
